import axios from "axios";

export const getMyApiKeys = async () => {
  try {
    const res: any = await axios.get(`/api-keys/my-keys`);
    return res?.data ? res.data : { items: [], total: 0 };
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const getAllApiKeys = async () => {
  try {
    const res: any = await axios.get(`/api-keys/admin/all`);
    return res?.data ? res.data : { items: [], total: 0 };
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const getApiKey = async ({ id }: { id: string }) => {
  try {
    const res: any = await axios.get(`/api-keys/${id}`);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const createApiKey = async ({ create }: any) => {
  try {
    const res: any = await axios.post(`/api-keys`, create);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const updateApiKey = async ({ id, update }: { id: string; update: any }) => {
  try {
    const res: any = await axios.put(`/api-keys/${id}`, update);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const revokeApiKey = async ({ id }: { id: string }) => {
  try {
    const res: any = await axios.patch(`/api-keys/${id}/revoke`);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const reactivateApiKey = async ({ id }: { id: string }) => {
  try {
    const res: any = await axios.patch(`/api-keys/${id}/reactivate`);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const deleteApiKey = async ({ id }: { id: string }) => {
  try {
    const res: any = await axios.delete(`/api-keys/${id}`);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

// Staff (isCompany) — company-scoped; the routes above are client-admin only.
export const adminCreateApiKey = async ({ create }: any) => {
  try {
    const res: any = await axios.post(`/api-keys/admin`, create);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const adminRevokeApiKey = async ({ id }: { id: string }) => {
  try {
    const res: any = await axios.patch(`/api-keys/admin/${id}/revoke`);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const adminReactivateApiKey = async ({ id }: { id: string }) => {
  try {
    const res: any = await axios.patch(`/api-keys/admin/${id}/reactivate`);
    return res?.data ? res.data : {};
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};
